import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromUser from './user.reducer';

export const selectUserState = createFeatureSelector<fromUser.UserState>(fromUser.userFeatureKey);

export const selectUser = createSelector(selectUserState, (state) => state.user);
export const selectUserError = createSelector(selectUserState, (state) => state.error);
